// generated by the plop

import { PROGRESS_STATUSES, UUID } from 'symbols';
import { TemplateModel } from '../../../pdf-templates/symbols';
import { InvoiceModel } from '../../symbols';

export interface InvoiceManageStateModel {
  currentInvoiceId: UUID;
  invoices: { [invoiceId: string]: InvoiceModel };
  loadInvoiceStatus: PROGRESS_STATUSES;
  updateInvoiceStatus: PROGRESS_STATUSES;
  realVersionInvoices: { [orderId: string]: InvoiceModel };
  invoiceTemplateList: TemplateModel[];
  waybillTemplateList: TemplateModel[];
  purchaseAgreementTemplateList: TemplateModel[];
  serviceCertificateTemplateList: TemplateModel[];
  acceptanceCertificateTemplateList: TemplateModel[];
  loadTemplateListStatus: PROGRESS_STATUSES;
}

export const INVOICE_MANAGE_STATE_DEFAULT: InvoiceManageStateModel = {
  currentInvoiceId: null,
  invoices: {},
  loadInvoiceStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateInvoiceStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  realVersionInvoices: {},
  invoiceTemplateList: [],
  waybillTemplateList: [],
  purchaseAgreementTemplateList: [],
  serviceCertificateTemplateList: [],
  acceptanceCertificateTemplateList: [],
  loadTemplateListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
